import { bookType } from '@/models/Book';
import Lesson from '@/models/Lesson';

import MaterialAddSection from './MaterialAddSection';
import MaterialSection from './MaterialSection';

type MaterialSubTabContentProps = {
  lesson: Lesson;
  bookType: bookType;
  isLimitedEdition?: boolean;
};

export default function MaterialSubTabContent({
  lesson,
  bookType,
  isLimitedEdition,
}: MaterialSubTabContentProps) {
  const bookId = bookType === 'STUDENT' ? lesson.book?.id : lesson.teacherBook;

  if (!bookId)
    return (
      <MaterialAddSection
        lessonId={lesson.id}
        bookType={bookType}
        isLimitedEdition={isLimitedEdition}
      />
    );

  return (
    <MaterialSection
      lessonId={lesson.id}
      bookType={bookType}
      bookId={bookId}
      isLimitedEdition={isLimitedEdition}
    />
  );
}
